import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const FUELPROVIDER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FuelProvider.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.FuelProvider.SapCode')
    .required()
    .minLength(1)
    .maxLength(15)
    .build(),
  FieldBuilder
    .text('oldSapCode', 'Entity.FuelProvider.OldSapCode')
    .maxLength(10)
    .build(),
];

export const FUELPROVIDER_CONFIG = {
  entityName: 'FuelProvider',
  localizationKey: 'Controlling::Entity.FuelProvider',
  fields: FUELPROVIDER_FIELDS,
  permission: 'GeneralConsumables.FuelProviders',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
